import moment from 'moment';
import history from 'libs/history';
import { getRoutes } from 'config/routes';
import { message } from 'antd';
import { defaultData } from 'context';
import { MapAudioVideoCheat } from './contants';
import { IRoute } from 'layouts/BasicLayout/components/Layout/SiderMenu';
import { isNil, isObject, cloneDeep } from 'lodash';
import { v4 as uuidV4 } from 'uuid';

export interface IOrganizationVO {
  id: string;
  name: string;
  type?: EnumOrganizationType;
  children?: IOrganizationVO[];
  users?: any[];
  levelId?: string;
  orgChainName?: string;
}

export enum EnumOrganizationType {
  ORGANIZATION = 'ORGANIZATION',
  USER = 'USER'
}

interface IOption {
  id: string;
  value: string;
  title: string;
  orgChain?: string;
  type?: EnumOrganizationType;
  children?: IOption[];
}

const getDuration = (time: number) => {
  if (!time) return '-';
  const du = moment.duration(time, 's');
  const mins: any = du.get('minutes') + 'm',
    ss: any = du.get('seconds') + 's';

  return mins + ss;
};
const getQueryByName = (name = '', url = window.location.search) => {
  const reg = new RegExp('[?&]' + name + '=([^&#]+)');
  const query = url.match(reg);
  return query ? decodeURIComponent(query[1]) : null;
};
const replaceQuery = (name = '', value = '', url = window.location.href) => {
  const query = getQueryByName(name);
  const newValue = encodeURIComponent(value);
  if (!query) {
    const reg = /[?]([^#]+)/;
    let search = url.match(reg);
    if (search) {
      const newSearch = search[0] + `&${name}=${newValue}`;
      return url.replace(search[0], newSearch);
    }
    const resultUrl = url.match(/[^#]+/);
    if (resultUrl) {
      return url.replace(resultUrl[0], resultUrl[0] + `?${name}=${newValue}`);
    }
    return url;
  }
  return url.replace(encodeURIComponent(query), newValue);
};
const goLogin = () => {
  console.log('go login');
  history.push('/admin/login');
};
const getRedirectUrl = () => {
  const redirectUrl = getQueryByName('redirectUrl');
  if (redirectUrl) return decodeURIComponent(redirectUrl);
  return '';
};
export const delQueryInUrl = (name = '', url = window.location.href) => {
  let query = getQueryByName(name);
  if (query) {
    let reg = new RegExp(`&?${name}=${encodeURIComponent(query)}`);
    return url.replace(reg, '');
  } else {
    return url;
  }
};
const download = (resp: any, name: string) => {
  console.log('download', resp instanceof Blob, resp);

  if (!(resp instanceof Blob)) {
    console.log('download--', resp);
    message.warning('下载失败');
    return;
  }
  console.log('bolb--');
  const url = URL.createObjectURL(resp);
  const downloadElement = document.createElement('a');
  downloadElement.href = url;
  downloadElement.download = decodeURIComponent(name);
  document.body.appendChild(downloadElement);
  downloadElement.click();
  document.body.removeChild(downloadElement);
  window.URL.revokeObjectURL(url);
};
export const formatNumber = (num: number): string => {
  let str = String(num);
  let i = 0;
  let length = str.length;
  while (i < length - 1) {
    const index = length - 1 - i;
    if ((i + 1) % 3 === 0) {
      str = str.slice(0, index) + ',' + str.slice(index);
      i++;
    }
    i++;
  }
  return str;
};

// 是否是列表总数的最后一条
const isListLastItem = (
  index: number,
  paginationInfo: { total: number; current: number; pageSize: number }
) => {
  const { total, current, pageSize } = paginationInfo;

  let nowIndex = index + 1;
  if (current === 1 && total === nowIndex) {
    return true;
  }
  if (current && current > 1 && pageSize) {
    let i = Number(pageSize) * (Number(current) - 1);
    i = i + nowIndex;
    if (total === i) {
      return true;
    }
  }
  return false;
};
export default {
  goLogin,
  getRedirectUrl,
  getQueryByName,
  replaceQuery,
  delQueryInUrl
};
export { getDuration, download, isListLastItem };

export const removeEmpty = (obj: { [key: string]: any }) => {
  Object.entries(obj).forEach(([key, val]) => {
    if (Array.isArray(val)) {
      if (val.length === 0) {
        delete obj[key];
      } else {
        removeEmpty(val);
      }
    } else if (typeof val === 'object' && val !== null) {
      removeEmpty(val);
    } else if (typeof val !== 'number' && typeof val !== 'boolean' && !val) {
      delete obj[key];
    }
  });
  return obj;
};

export const excludeKeyFromObj = (obj: { [key: string]: any }, excludeKeys: string[]) => {
  return Object.entries(obj).reduce((curr, [key, value]) => {
    if (!excludeKeys.includes(key)) {
      curr[key] = value;
    }
    return curr;
  }, {} as { [key: string]: any });
};

// 保留两位小数
export const limitDecimals = (value: string | number | undefined) => {
  const reg = /^(\-)*(\d+)\.(\d\d).*$/;
  if (typeof value === 'string') {
    return !isNaN(Number(value)) ? value.replace(reg, '$1$2.$3') : '';
  } else if (typeof value === 'number') {
    return !isNaN(value) ? String(value).replace(reg, '$1$2.$3') : '';
  } else {
    return '';
  }
};

//  查找节点
export const treeFindNode = (
  tree: IOption[],
  isTargetNode: (node: IOption) => boolean
): null | IOption => {
  if (!tree) return null;
  for (const node of tree) {
    if (isTargetNode(node)) return node;
    if (node.children) {
      const childrenNode = treeFindNode(node.children, isTargetNode);
      if (childrenNode) return childrenNode;
    }
  }
  return null;
};

//  查找节点路径
export const treeFindPath = (
  tree: IOption[],
  isTargetNode: (node: IOption) => boolean,
  path: string[] = []
): string[] => {
  if (!tree) return [];
  for (const node of tree) {
    path.push(node.id);
    if (isTargetNode(node)) return path;
    if (node.children) {
      const findChildren = treeFindPath(node.children, isTargetNode, path);
      if (findChildren?.length) return findChildren;
    }
    path.pop();
  }
  return [];
};

//  树的遍历相关

export interface Item {
  id: string;
  name: string;
  type: string;
  level?: number;
  orgChain?: string;
  children: Item[] | null;
}

//  树的广度遍历
export const getNodeHashMapByBfs = (
  tree: Item[],
  handleNode: (node: Item, map: Map<string, string[]>) => void
) => {
  let list = [...tree];
  let node;
  const hashMap = new Map<string, string[]>();
  while ((node = list.shift())) {
    handleNode(node, hashMap);
    node.children && list.push(...node.children);
  }
  return hashMap;
};

// ant design 的 Cascader组件 多选 选择值改变时，选到最后一级
export const handleNode = (node: Item, map: Map<string, string[]>) => {
  //  传入一个节点，记录这个节点的所有叶子节点
  const getLeafNodeIdsWithNode = (node: Item) => {
    const ids = [];
    if (!node.children?.length) {
      ids.push(node.id);
      return ids;
    }
    let list = [...node.children];
    let _node;
    while ((_node = list.shift())) {
      if (!_node.children?.length) {
        ids.push(_node.id);
      }
      _node.children && list.push(..._node.children);
    }
    return ids;
  };

  const ids = getLeafNodeIdsWithNode(node);
  map.set(node.id, ids);
};

// 树转列表
export const treeToList = (tree: Item[], result: Item[] = [], level: number = 1) => {
  tree.forEach(node => {
    result.push(node);
    node.level = level++;
    node.children && treeToList(node.children, result, level);
  });
  return result;
};

// 音视频作弊检测
export const audioVideoCheatCheck = (audioVideoCheatCheckResults: any[]) => {
  if (audioVideoCheatCheckResults && Array.isArray(audioVideoCheatCheckResults)) {
    let map: string[] = [];
    audioVideoCheatCheckResults.forEach(record => {
      // 音频作弊，为0就是作弊，视频作弊，为1就是作弊
      if (record.audioCheatResult) {
        for (let key in record.audioCheatResult) {
          if (
            record.audioCheatResult.hasOwnProperty(key) &&
            MapAudioVideoCheat.hasOwnProperty(key) &&
            !record.audioCheatResult[key]
          ) {
            map.push(MapAudioVideoCheat[key]);
          }
        }
      }
      if (record.videoCheatResult) {
        for (let key in record.videoCheatResult) {
          if (
            record.videoCheatResult.hasOwnProperty(key) &&
            MapAudioVideoCheat.hasOwnProperty(key) &&
            record.videoCheatResult[key]
          ) {
            map.push(MapAudioVideoCheat[key]);
          }
        }
      }
    });
    return map;
  }
  return [];
};
export const unitsToOptions = (list: IOrganizationVO[]): IOption[] => {
  if (list.length <= 0) return [];
  const data = list.map(o => {
    // 把user转换成organization，通过type辨识
    const users = (o.users || []).map(o => ({
      id: o.id || '',
      name: o.name || o.account || '',
      type: EnumOrganizationType.USER
    }));
    const orgs = (o.children || []).map(o => ({
      ...o,
      id: o.id,
      name: o.name,
      type: EnumOrganizationType.ORGANIZATION
    }));
    const children = orgs.concat(users);

    return {
      id: o.id || '',
      value: `${o.id}-${o.type || EnumOrganizationType.ORGANIZATION}` || '',
      key: o.id || '',
      title: o.name,
      type: o.type || EnumOrganizationType.ORGANIZATION,
      children: unitsToOptions(children || [])
    };
  });
  return data;
};

// 递归算法获取所有叶子节点
export const getAllLeafIds = (data: IOption[]) => {
  let result: string[] = [];
  function getLeaf(data: IOption[]) {
    data.forEach(item => {
      if (!item.children?.length) {
        if (item.type === EnumOrganizationType.USER) {
          result.push(item.id);
        }
      } else {
        getLeaf(item.children);
      }
    });
  }
  getLeaf(data);
  return result;
};

// input输入数字带小数考验

export const NumberDecimalRegExp = new RegExp(/^\d*\.?\d*$/);

export const mapDecimalPlacesTip = [
  '当前数值只允许带一位小数',
  '当前数值只允许带两位小数',
  '当前数值只允许带三位小数',
  '当前数值只允许带四位小数'
];

export const checkDecimalNumber = (decimalNumber: string, decimalPlaces: number, tip = '') => {
  if (decimalNumber !== '' && !NumberDecimalRegExp.test(decimalNumber)) {
    message.warn('只能输入数字或者小数点');
    return false;
  }
  const numberPart = decimalNumber.split('.');
  const decimalPart = numberPart?.[1];
  if (decimalPart && decimalPart.length > decimalPlaces) {
    message.warn(tip || mapDecimalPlacesTip?.[decimalPlaces - 1] || '小数部分不合法，请重新输入');
    return false;
  }
  return true;
};

export function isPromise(obj: unknown): obj is Promise<unknown> {
  return !!obj && typeof obj === 'object' && typeof (obj as any).then === 'function';
}

export const validateByteLen = (str: string, maxByteNum: number = 20) => {
  let len = 0;
  const reg = /[\u4e00-\u9fa5]/;
  for (let i = 0; i < str?.length; i++) {
    if (reg.test(str.charAt(i))) {
      len += 2;
    } else {
      len++;
    }
  }
  return len > maxByteNum;
};

// 通过code获取对应routes
export const getRoutesByCode = (arr: { code: string }[]) => {
  let result: any = [];
  let codeMap: any = {};
  let codeArr = arr.map(v => {
    codeMap[v.code] = v;
    return v.code;
  });

  function getRoute(routes: IRoute[]) {
    routes.forEach((route: any) => {
      if (codeArr.includes(route.code)) {
        result.push(
          Object.assign(codeMap[route.code], {
            label: route.name,
            path: route.routes ? route.routes[0].path : route.path
          })
        );
      } else {
        if (route.routes) {
          getRoute(route.routes);
        }
      }
    });
  }
  getRoute(getRoutes(defaultData?.coachConfig2 || {}));

  return result;
};

export const removeNullValues = (object: any) => {
  if (!isObject(object)) return object;

  return Object.entries(object).reduce((acc, [key, value]) => {
    if (value === null) {
      return acc;
    }
    if (Array.isArray(value)) {
      // 数组
      return { ...acc, [key]: value };
    }
    if (isObject(value)) {
      const filteredValue = removeNullValues(value) as any;
      if (Object.entries(filteredValue).length === 0) {
        return acc;
      }
      return { ...acc, [key]: filteredValue };
    }
    return { ...acc, [key]: value };
  }, {});
};

export const formatDecimal = (value?: string | number, n: number = 1) => {
  if (value === null || value === undefined) {
    return '-';
  }
  if (typeof value === 'string' || typeof value === 'number') {
    return Math.floor(+value * Math.pow(10, n)) / Math.pow(10, n);
  }
  return '-';
};

export const base64ToBlob = (code: string) => {
  let parts = code.split(';base64,');
  let contentType = parts[0].split(':')[1];
  let raw = window.atob(parts[1]);

  let rawLength = raw.length;
  let uInt8Array = new Uint8Array(rawLength);
  for (let i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }
  return new window.Blob([uInt8Array], { type: contentType });
};

// 如果文本长度超过 canvas 宽度，将字符串分割成两串
export const sliceText = (ctx: any, canvas: any, text: string) => {
  const canvasWidth = canvas.width;
  const textWidth = ctx.measureText(text).width;
  if (textWidth > canvasWidth) {
    const textArr: string[] = [];
    const splitLength = parseInt(String(text.length / 2));
    for (let i = 0; i < text.length; i += splitLength) {
      const newString = text.slice(i, i + splitLength);
      const strArr = sliceText(ctx, canvas, newString);
      textArr.push(...strArr);
    }
    return textArr;
  }
  return [text];
};
// canvas绘制文字，居中换行显示
export const fillText = (ctx: any, canvas: any, text: any) => {
  ctx.fillStyle = '#333';
  ctx.font = '14px 微软雅黑';
  const canvasWidth = canvas.width;
  const textArray = sliceText(ctx, canvas, text) || [];
  let textArr = textArray;
  if (Array.isArray(textArray) && textArray.length > 3) {
    textArr = textArray.slice(0, 3); // 如果超过3行，截取前3行
    textArr.push('...'); // 添加省略号
  }
  const maxLine = 8;
  let initY = (maxLine - textArr?.length) * 18;
  initY = initY < 10 ? 10 : initY;
  textArr.forEach((i: any, index: number) => {
    const y = initY + (index + 1) * 20;
    const textWidth = ctx.measureText(i).width;
    const xPosition = canvasWidth / 2 - textWidth / 2;

    ctx.fillText(i, xPosition, y);
  });
};
// 利用canvas 重新绘制图片
export const repeatDrawImage = (imageString: string, name: any) => {
  if (!imageString) {
    return null;
  }
  const imgDom = document.createElement('img');
  imgDom.src = imageString;
  imgDom.style.width = 'auto';
  imgDom.style.height = 'auto';
  imgDom.style.maxWidth = '400px';
  imgDom.style.maxHeight = '400px';
  imgDom.style.textAlign = 'center';

  const canvas = document.createElement('canvas');
  canvas.width = 600;
  canvas.height = 600;
  canvas.style.width = '600px';
  canvas.style.height = '600px';

  // document.body.appendChild(imgDom)
  // document.body.appendChild(canvas)

  const ctx: any = canvas.getContext('2d');
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, 600, 600);
  let returnImageData: any = '';

  return new Promise((resolve, reject) => {
    imgDom.onload = () => {
      fillText(ctx, canvas, name);
      ctx.drawImage(imgDom, 100, 190, 400, 400);
      returnImageData = canvas.toDataURL('image/png', {
        quality: 1,
        width: 610,
        height: 610
      } as any);
      return resolve(returnImageData);
    };
    imgDom.onerror = () => {
      message.warning('图片加载失败啦');
      return resolve('');
    };
  });
};
// import {testData} from './imageData'
// picSrc:'data:image/jpeg;base64,xxxxxxxxx'
// data 场景，情境对象
export const downImage64 = async (picSrc: string, data: any) => {
  let imageUrl = `data:image/jpeg;base64,${picSrc}`;
  let name: string = '';
  if (data?.identityName) {
    name = name + `${data?.identityName ? `${data?.identityName} - ` : ''}`;
  }
  if (data?.groupName) {
    name = name + `${data?.groupName ? `${data?.groupName} - ` : ''}`;
  }
  if (data?.unitName) {
    name = name + `${data?.unitName ? `${data?.unitName} - ` : ''}`;
  }
  name = name + `${data?.id || ''}`;

  const CanvasImageData: any = await repeatDrawImage(imageUrl, name);

  if (!CanvasImageData) {
    return;
  }
  let blob = base64ToBlob(CanvasImageData); // 转码
  const filename = `${name}.png`;
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  document.body.appendChild(a);
  a.href = url;
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
};

export const validateFileExtension = (
  filename: string
): {
  status: boolean;
  message?: string;
} => {
  if (!filename) {
    return {
      status: false,
      message: '没有文件信息'
    };
  }
  // 定义允许上传的文件后缀名数组
  const allowedExtensions = [
    'jpg',
    'jpeg',
    'png',
    'gif',
    'bmp',
    'svg',
    'webp',
    'ico',
    'tif',
    'tiff',
    'eps',
    'raw',
    'psd',
    'ai',
    'pdf',
    'doc',
    'docx',
    'xls',
    'xlsx',
    'ppt',
    'pptx',
    'txt',
    'rtf',
    'csv',
    'odt',
    'ods',
    'odp',
    'md',
    'html',
    'htm',
    'xml',
    'json',
    'yaml',
    'yml',
    'mp4',
    'avi',
    'mov',
    'wmv',
    'flv',
    'mkv',
    '3gp',
    'mpg',
    'mpeg',
    'm4v',
    'rmvb',
    'webm',
    'swf',
    'vob',
    'ts',
    'f4v',
    'ogv',
    'm2v',
    'mp3',
    'wav',
    'm4a',
    'aac',
    'ogg',
    'wma',
    'flac',
    'ape',
    'alac',
    'amr',
    'mid',
    'midi',
    'ac3',
    'dts',
    'ra',
    'zip',
    'rar',
    '7z',
    'tar',
    'gz',
    'bz2',
    'xz',
    'z',
    'tgz',
    'cab',
    'iso',
    'dmg',
    'jar',
    'war',
    'ear',
    'apk',
    'ipa',
    'deb',
    'rpm',
    'sitx',
    'sit',
    'exe',
    'msi',
    'bat',
    'cmd',
    'sh',
    'app',
    'com',
    'jar',
    'py',
    'rb',
    'pl',
    'php',
    'html',
    'js',
    'css',
    'dll',
    'so',
    'a',
    'class',
    'sql',
    'db',
    'mdb',
    'accdb',
    'sqlite',
    'dbf',
    'bak',
    'log',
    'trc',
    'mdf',
    'ldf',
    'torrent',
    'bak',
    'cfg',
    'conf',
    'ini',
    'sys',
    'tmp',
    'bak',
    'swp',
    'swo',
    'part',
    'crdownload',
    'torrent',
    'eml',
    'msg',
    'pst',
    'ost',
    'emlx',
    'dmp',
    'log',
    'bak',
    'old',
    'new',
    'backup',
    'patch',
    'diff',
    'ps',
    'eps',
    'ai',
    'indd',
    'cdr',
    'dwg',
    'dxf',
    'stl',
    'obj',
    '3dm',
    '3ds',
    'max',
    'blend',
    'ma',
    'mb',
    'fbx',
    'skp',
    'dwf',
    'rvt',
    'ifc',
    'nwc',
    'nwd',
    'step',
    'iges',
    'stp',
    'sat',
    'sldprt',
    'sldasm',
    'asm',
    'prt',
    'par',
    'ipj',
    'iam',
    'idw',
    'ipt',
    'x_t',
    'x_b',
    '3dxml',
    'cgr',
    'catpart',
    'catproduct',
    'prt',
    'asm',
    'neu',
    'psm',
    'asm',
    'xas',
    'xpr',
    'xmt',
    'xft',
    'exp',
    'model',
    'mod',
    'dem',
    'vdf',
    'msh',
    'mesh',
    'ply',
    'obj',
    'fbx',
    '3ds',
    'dae',
    'x3d',
    'wrl',
    'vrml',
    'stl',
    'iges',
    'step',
    'sat',
    'brep',
    'brp',
    'dwg',
    'dxf',
    'ifc',
    'nwc',
    'nwd',
    'rfa',
    'rvt',
    'max'
  ];

  // 获取文件后缀名
  const extensions = filename?.split('.').filter(Boolean);
  const allowedExtensionLen =
    extensions?.filter(o => allowedExtensions.includes(o.toLowerCase()))?.length || 0;

  // 校验文件后缀名是否在允许上传的后缀名数组中
  if (allowedExtensionLen === 0) {
    return {
      status: false,
      message: '文件必须有一个后缀名'
    };
  } else if (allowedExtensionLen > 1) {
    return {
      status: false,
      message: '文件只能包含一个后缀'
    };
  } else {
    return {
      status: true,
      message: ''
    };
  }
};

export const getFileType = (filename?: string) => {
  if (!filename) return '';
  const extensions = filename?.split('.').filter(Boolean);
  if (extensions?.length <= 1) {
    return '';
  }
  return extensions[extensions?.length - 1];
};

export const getFileNameNotType = (filename?: string) => {
  if (!filename) return '';
  const extensions = filename?.split('.').filter(Boolean);
  if (extensions?.length <= 1) {
    return filename;
  }
  return extensions?.[0];
};

export const getFileUuidAndType = (filename: string) => {
  const id = uuidV4();
  const fileType = getFileType(filename);
  if (!fileType) return id;
  return `${id}.${fileType}`;
};

// 验证正则的合法性
export const isRegexValid = (pattern: any) => {
  try {
    new RegExp(pattern);
    return true; // 正则表达式合法
  } catch (error) {
    return false; // 正则表达式不合法
  }
};

export const excludeNil = (val: any) => {
  if (isNil(val)) {
    return '-';
  }
  return val;
};

// 判断数组区间是否有重合
export function checkArrayIntervalOverLap(
  arrArea: { [key: string]: number }[],
  lowerKey: string,
  upperKey: string
) {
  let result = false;
  let areaLength = arrArea.length;
  if (areaLength > 1) {
    for (let i = 0; i < areaLength - 1; i++) {
      let start1 = arrArea[i]?.[lowerKey];
      let end1 = arrArea[i]?.[upperKey];
      for (let j = i + 1; j < areaLength; j++) {
        let start2 = arrArea[j]?.[lowerKey];
        let end2 = arrArea[j]?.[upperKey];
        if (Math.max(start1, start2) < Math.min(end1, end2)) {
          result = true;
        }
      }
    }
  }
  return result;
}

/** 判断任何类型的值是否是数字 */
export const anyIsNumber = (val: any): boolean => {
  // 只判断字符串和数字
  if (typeof val === 'string' || typeof val === 'number') {
    return !Number.isNaN(Number(val));
  }
  return false;
};

export const sleep = (ms: number) => {
  return new Promise(res => {
    setTimeout(() => {
      res(true);
    }, ms);
  });
};

interface TreeFieldNames {
  /** id对应的字段，默认 'id' */
  id?: string;
  /** children对应的字段 默认 'children' */
  children?: string;
  filterData: (string | number)[];
}

export const filterTreeNode = (tree: any[], opts: TreeFieldNames) => {
  const { id = 'id', children = 'children', filterData = [] } = opts || {};
  // 没有需要过滤的数据，直接返回
  if (!Array.isArray(filterData) || !filterData.length) {
    return tree;
  }
  if (!Array.isArray(tree)) return [];

  // 先移除外层数据
  const newTree = cloneDeep(tree);
  // 然后递归移除children里面的数据
  for (let i = 0; i < newTree.length; i++) {
    if (filterData.includes(newTree[i]?.[id])) {
      newTree[i].disabled = true;
    }
    if (Array.isArray(newTree[i]?.[children])) {
      newTree[i][children] = filterTreeNode(newTree[i][children], opts);
    }
  }
  return newTree;
};

/** 递归所有节点，获取对应id(不一定是id，可以通过fieldNames参数修改) */
export const recurseTree = <
  T extends {
    value?: string;
    children?: string;
  }
>(
  tree: any,
  fieldNames?: T
) => {
  const ids: (string | number)[] = [];
  const names = fieldNames ?? { value: 'id', children: 'children' };
  const id = names.value as string;
  const children = names.children as string;
  function recurse(currentNode: any) {
    if (!currentNode) {
      return;
    }
    // 将当前节点的 id 添加到 ids 数组中
    if (currentNode[id]) {
      ids.push(currentNode[id]);
    }
    // 检查是否有 children，并且 children 是否非空数组
    if (Array.isArray(currentNode[children]) && currentNode[children].length > 0) {
      // 对每个子节点递归调用 recurse 函数
      for (let child of currentNode[children]) {
        recurse(child);
      }
    }
  }

  if (Array.isArray(tree)) {
    tree.forEach(item => {
      recurse(item);
    });
  } else {
    // 从树的根开始递归
    recurse(tree);
  }
  return ids;
};

export const copyTextToClipboard = async (text: string) => {
  await navigator.clipboard.writeText(text);
};
